/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svchip_Greeting_FlowsInputs */

const en_svchip_greeting_flows = /** @type {(inputs: Svchip_Greeting_FlowsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Greeting flows`)
};

const ar_svchip_greeting_flows = /** @type {(inputs: Svchip_Greeting_FlowsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`تدفقات التحية`)
};

const bn_svchip_greeting_flows = /** @type {(inputs: Svchip_Greeting_FlowsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`শুভেচ্ছা প্রবাহ`)
};

const de_svchip_greeting_flows = /** @type {(inputs: Svchip_Greeting_FlowsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Begrüßungsabläufe`)
};

const es_svchip_greeting_flows = /** @type {(inputs: Svchip_Greeting_FlowsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Flujos de saludo`)
};

const fr_svchip_greeting_flows = /** @type {(inputs: Svchip_Greeting_FlowsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Scénarios d'accueil`)
};

const pt_svchip_greeting_flows = /** @type {(inputs: Svchip_Greeting_FlowsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fluxos de saudação`)
};

const zh_svchip_greeting_flows = /** @type {(inputs: Svchip_Greeting_FlowsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`问候流程`)
};

const tr_svchip_greeting_flows = /** @type {(inputs: Svchip_Greeting_FlowsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Karşılama akışları`)
};

const ru_svchip_greeting_flows = /** @type {(inputs: Svchip_Greeting_FlowsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Сценарии приветствия`)
};

const pl_svchip_greeting_flows = /** @type {(inputs: Svchip_Greeting_FlowsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Scenariusze powitań`)
};

/**
* | output |
* | --- |
* | "Greeting flows" |
*
* @param {Svchip_Greeting_FlowsInputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
export const svchip_greeting_flows = /** @type {((inputs?: Svchip_Greeting_FlowsInputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svchip_Greeting_FlowsInputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_svchip_greeting_flows(inputs)
	if (locale === "bn") return bn_svchip_greeting_flows(inputs)
	if (locale === "de") return de_svchip_greeting_flows(inputs)
	if (locale === "es") return es_svchip_greeting_flows(inputs)
	if (locale === "fr") return fr_svchip_greeting_flows(inputs)
	if (locale === "pt") return pt_svchip_greeting_flows(inputs)
	if (locale === "zh") return zh_svchip_greeting_flows(inputs)
	if (locale === "tr") return tr_svchip_greeting_flows(inputs)
	if (locale === "ru") return ru_svchip_greeting_flows(inputs)
	if (locale === "pl") return pl_svchip_greeting_flows(inputs)
	return en_svchip_greeting_flows(inputs)
});